import { defineMessages } from 'react-intl';

export const iCalMessages = {
  stepOne: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.i-cal.first-step.title',
      defaultMessage: 'Welcome to Calendar Sync',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.i-cal.first-step.paragraph-one',
      defaultMessage:
        'By linking an external calendar to your ClassPass practitioners, it enables Calendar Sync to seamlessly block availability on ClassPass, preventing double bookings.',
    },
    paragraphTwo: {
      id: 'calsync.tutorial-modal.i-cal.first-step.paragraph-two',
      defaultMessage:
        'Once you have connected the appropriate calendar to your practitioners or equipment, Calendar Sync will listen to new events provided by your scheduling platform or calendar application and add them to ClassPass as calendar blocks.',
    },
  }),
  stepTwo: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.i-cal.second-step.title',
      defaultMessage: 'Adding your Calendar Links',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.i-cal.second-step.paragraph-one',
      defaultMessage:
        "After you have added your practitioners' core availability to ClassPass (if you haven’t yet, <a>add practitioners here</a>) you will be able to input a calendar link for each of your practitioners or equipment.",
    },
    paragraphTwo: {
      id: 'calsync.tutorial-modal.i-cal.second-step.paragraph-two',
      defaultMessage:
        "For each unique practitioner you will need to input a unique calendar link to ensure any new calendar events don't block all of your practitioners.",
    },
    paragraphThree: {
      id: 'calsync.tutorial-modal.i-cal.second-step.paragraph-three',
      defaultMessage:
        'You can find your calendar links in your scheduling platform or calendar application. If you have selected a specific platform a guide will be provided on the following screen.',
    },
  }),
  stepThree: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.i-cal.third-step.title',
      defaultMessage: 'See your events all in one place',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.i-cal.third-step.paragraph-one',
      defaultMessage:
        'Once synced, any events on your external calendar will now block availability on your ClassPass calendar.',
    },
  }),
  stepFour: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.i-cal.fourth-step.title',
      defaultMessage: 'Exporting your ClassPass appointments',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.i-cal.fourth-step.paragraph-one',
      defaultMessage:
        "By clicking 'Share ClassPass calendar' you'll be able to access a live feed of your future ClassPass appointments. You can add this feed to your scheduling platform.",
    },
    paragraphTwo: {
      id: 'calsync.tutorial-modal.i-cal.fourth-step.paragraph-two',
      defaultMessage:
        "<emphasis>Please note:</emphasis> Not all scheduling platforms or calendar applications support this feature. Please check the 'Things to know' section on the following screen. Regardless, you will still be able to access this feed.",
    },
    paragraphThree: {
      id: 'calsync.tutorial-modal.i-cal.fourth-step.paragraph-three',
      defaultMessage:
        'If you’d like to learn more about setting up Calendar Sync, <a>see more details on our support site</a>',
    },
  }),
};

export const iCalCtaMessages = [
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.i-cal.first-step.cta',
      defaultMessage: 'Adding your links',
    },
  }),
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.i-cal.second-step.cta',
      defaultMessage: 'All in one place',
    },
  }),
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.i-cal.third-step.cta',
      defaultMessage: 'Exporting appointments',
    },
  }),
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.i-cal.fourth-step.cta',
      defaultMessage: 'Close tutorial',
    },
  }),
];

export const googleMessages = {
  stepOne: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.google.first-step.title',
      defaultMessage: 'Welcome to Calendar Sync',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.google.first-step.paragraph-one',
      defaultMessage:
        'By linking your Google Calendar to ClassPass, it enables Calendar Sync to seamlessly block availability on ClassPass, preventing double bookings.',
    },
    paragraphTwo: {
      id: 'calsync.tutorial-modal.google.first-step.paragraph-two',
      defaultMessage:
        'Once you have connected the appropriate calendar to your practitioners or equipment, Calendar Sync will listen to any new events added to your Google Calendar and add them to ClassPass as calendar blocks.',
    },
  }),
  stepTwo: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.google.second-step.title',
      defaultMessage: 'Assigning your Calendars',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.google.second-step.paragraph-one',
      defaultMessage:
        "After you have added your practitioners' core availability to ClassPass you will be able to assign a specific Google Calendar to your practitioner.",
    },
    paragraphTwo: {
      id: 'calsync.tutorial-modal.google.second-step.paragraph-two',
      defaultMessage: 'Practitioners and equipment can be assigned to specific calendars within your Google account.',
    },
    learnHow: {
      id: 'calsync.tutorial-modal.google.second-step.learn-how',
      defaultMessage: 'Learn how to add multiple calendars to your Google account',
    },
  }),
  stepThree: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.google.third-step.title',
      defaultMessage: 'See your events all in one place',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.google.third-step.paragraph-one',
      defaultMessage:
        'Once synced, any events from your Google Calendar will now block availability on your ClassPass calendar.',
    },
  }),
  stepFour: defineMessages({
    title: {
      id: 'calsync.tutorial-modal.google.fourth-step.title',
      defaultMessage: 'Sync in both directions',
    },
    paragraphOne: {
      id: 'calsync.tutorial-modal.google.fourth-step.paragraph-one',
      defaultMessage:
        'With your Google Calendar synced, ClassPass appointments will also automatically be added to your Google Calendar, reducing administrative tasks and increasing efficiency.',
    },
    paragraphTwo: {
      id: 'calsync.tutorial-modal.google.fourth-step.paragraph-two',
      defaultMessage:
        'If you’d like to learn more about setting up Calendar Sync, <a>see more details on our support site</a>',
    },
  }),
};

export const googleCtaMessages = [
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.google.first-step.cta',
      defaultMessage: 'Adding your links',
    },
  }),
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.google.second-step.cta',
      defaultMessage: 'All in one place',
    },
  }),
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.google.third-step.cta',
      defaultMessage: 'Sync in both directions',
    },
  }),
  defineMessages({
    cta: {
      id: 'calsync.tutorial-modal.google.fourth-step.cta',
      defaultMessage: 'Close tutorial',
    },
  }),
];
